const config = {
    dev: {
        API_END_POINT_URI: process.env.VUE_APP_API_ENDPOINT,
        apiXToken: process.env.VUE_APP_API_X_TOKEN,
        projectName: 'Coda - dev',
        projectStage: 'dev',
        cognitoAuthority: process.env.VUE_APP_COGNITO_AUTHORITY,
        cognitoDomain: process.env.VUE_APP_COGNITO_DOMAIN,
        cognitoLogout: process.env.VUE_APP_COGNITO_LOGOUT_URI,
        cognitoPoolClientID: process.env.VUE_APP_COGNITO_POOL_CLIENTID,
        cognitoRedirect: process.env.VUE_APP_COGNITO_REDIRECT,
        cognitoResponseType: process.env.VUE_APP_COGNITO_RESPONSE_TYPE,
        cognitoScope: process.env.VUE_APP_COGNITO_SCOPE,
    },
    beta: {
        API_END_POINT_URI: process.env.VUE_APP_API_ENDPOINT,
        apiXToken: process.env.VUE_APP_API_X_TOKEN,
        projectName: 'Coda - beta',
        projectStage: 'beta',
        cognitoAuthority: process.env.VUE_APP_COGNITO_AUTHORITY,
        cognitoDomain: process.env.VUE_APP_COGNITO_DOMAIN,
        cognitoLogout: process.env.VUE_APP_COGNITO_LOGOUT_URI,
        cognitoPoolClientID: process.env.VUE_APP_COGNITO_POOL_CLIENTID,
        cognitoRedirect: process.env.VUE_APP_COGNITO_REDIRECT,
        cognitoResponseType: process.env.VUE_APP_COGNITO_RESPONSE_TYPE,
        cognitoScope: process.env.VUE_APP_COGNITO_SCOPE,
    },
    staging: {
        API_END_POINT_URI: process.env.VUE_APP_API_ENDPOINT,
        apiXToken: process.env.VUE_APP_API_X_TOKEN,
        projectName: 'Coda - staging',
        projectStage: 'staging',
        cognitoAuthority: process.env.VUE_APP_COGNITO_AUTHORITY,
        cognitoDomain: process.env.VUE_APP_COGNITO_DOMAIN,
        cognitoLogout: process.env.VUE_APP_COGNITO_LOGOUT_URI,
        cognitoPoolClientID: process.env.VUE_APP_COGNITO_POOL_CLIENTID,
        cognitoRedirect: process.env.VUE_APP_COGNITO_REDIRECT,
        cognitoResponseType: process.env.VUE_APP_COGNITO_RESPONSE_TYPE,
        cognitoScope: process.env.VUE_APP_COGNITO_SCOPE,
    },
    prod: {
        API_END_POINT_URI: process.env.VUE_APP_API_ENDPOINT,
        apiXToken: process.env.VUE_APP_API_X_TOKEN,
        projectName: 'Coda',
        projectStage: 'prod',
        cognitoAuthority: process.env.VUE_APP_COGNITO_AUTHORITY,
        cognitoDomain: process.env.VUE_APP_COGNITO_DOMAIN,
        cognitoLogout: process.env.VUE_APP_COGNITO_LOGOUT_URI,
        cognitoPoolClientID: process.env.VUE_APP_COGNITO_POOL_CLIENTID,
        cognitoRedirect: process.env.VUE_APP_COGNITO_REDIRECT,
        cognitoResponseType: process.env.VUE_APP_COGNITO_RESPONSE_TYPE,
        cognitoScope: process.env.VUE_APP_COGNITO_SCOPE,
    }
}

const featureflags =  {
    dev: {
        useShadows: false,
        useSideNav: false,
    },
    beta: {
        useShadows: false,
        useSideNav: false,
    },
    staging: {
        useShadows: false,
        useSideNav: false,
    },
    prod: {
        useShadows: false,
        useSideNav: false,
    }
}
const stage = process.env.APP_STAGE || 'dev';
export const myConfig = config[stage];
export const myFeatures = featureflags[stage];
export default {
    myConfig,
    myFeatures
}